module.exports = __webpack_public_path__ + "img/clone-reverse.fbd58fdb.svg";